module.exports = "<p>\r\n  accountreports works!\r\n</p>\r\n"